module.exports = __webpack_public_path__ + "static/img/frame_wac_family.a76c667.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/certificate/frame_wac_family.png
// module id = i8Gz
// module chunks = 1